import React from "react";
import { Modal } from "reactstrap";
import InvoiceSummaryForm from "./InvoiceSummaryForm";

const InvoiceSummaryModal = ({ program, isOpen, setOpen, toggle }) => {
  const props = { btnLabel: "Download Invoice Summary", program, setOpen, toggle };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Reports</span>
          <h3 className="modal-2col__title">Invoice Summary</h3>
          <p className="modal-2col__description">
            Choose a date range to download a PDF summary of invoice activity
            for the selected program. Use this report to review funding history
            and support reconciliation.
          </p>
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <InvoiceSummaryForm {...props} />
      </div>
    </Modal>
  );
};

export default InvoiceSummaryModal;
